import React, { Component } from 'react';

export default class Timer extends Component {
  constructor(props) {
    super(props);
    this.resendOTP = this.resendOTP.bind(this);

    this.state = {
      start: Date.now(),
      diff: 0,
      minutes: 0,
      seconds: 0,
      duration: 60 * 0.5,
      resend: false,
    };
    this.timerState = '';
    this.timerCount = '';
    this.count = 0;
  }

  componentDidMount() {
    window.clearInterval(this.timerCount);
    this.timerCount = setInterval(() => {
      this.timer();
    }, 1000);
  }

  starttimer() {
    window.clearInterval(this.timerCount);
    this.timerCount = setInterval(() => {
      this.timer();
    }, 1000);
  }

  componentWillUnmount() {
    window.clearInterval(this.timerCount);
  }

  timer() {
    let diff = this.state.diff;
    let minutes = this.state.minutes;
    let seconds = this.state.seconds;

    diff = this.state.duration - (((Date.now() - this.state.start) / 1000) | 0);
    minutes = (diff / 60) | 0;
    seconds = diff % 60 | 0;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    this.setState({ minutes: minutes, seconds: seconds });

    if (diff <= 0) {
      this.setState({ resend: true });
      window.clearInterval(this.timerCount);
    }
  }

  resendOTP(evt) {
    if (this.state.minutes === '00' && this.state.seconds === '00') {
      const { resendOtp } = this.props;
      this.setState({ start: Date.now(), minutes: 0, seconds: 0, duration: 60 * 0.5 });
      resendOtp && resendOtp();
      this.starttimer();
      evt.preventDefault();
    }
  }

  render() {
    const { minutes, seconds } = this.state;
    return (
      <div>
        <a className={`Button PauseButton ${minutes === '00' && seconds === '00' ? 'resend-link' : 'disabled-link'}`} onClick={this.resendOTP}>
          Resend
        </a>
        <span className="Bloc-timer" style={{ color: 'gray' }}>
          {' '}
          in {minutes === 0 ? '00' : minutes} : {seconds === 0 ? '00' : seconds}
        </span>
      </div>
    );
  }
}
